import axios from 'axios';
import cn from 'classnames';
import isEmpty from 'lodash.isempty';
import { useEffect, useState } from 'react';
import { Form, Link, useActionData } from 'react-router-dom';

export async function action({ request /*params */ }) {
	const formData = await request.formData();
	const data = Object.fromEntries(formData);
	const password = data.password1;
	try {
		await axios.post('/clients/reset_user_password', {
			password,
			accessToken: data.accessToken,
		});
	} catch (error) {
		return { error };
	}
	return { submitted: true };
}

const ChangePassword = () => {
	const actionData = useActionData();
	const paramsString = window.location.hash.split('?')[1] || '';
	const searchParams = new URLSearchParams(paramsString);
	const [password1, setPassword1] = useState('');
	const [password2, setPassword2] = useState('');
	const [passwordsMatch, setPasswordsMatch] = useState(true);

	useEffect(() => {
		if (isEmpty(password2)) {
			setPasswordsMatch(true);
			return;
		}
		setPasswordsMatch(password1 === password2);
	}, [password1, password2]);

	const handleValidate = (e) => {
		if (password1 !== password2) {
			e.preventDefault();
		}
	};

	return (
		<div className="justify-center py-12 page">
			<div className="sm:mx-auto sm:w-full sm:max-w-sm">
				<h2>Change Password</h2>
			</div>
			<div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
				{actionData?.submitted ? (
					<>
						<p className="pb-4">
							Password change successful. You can now{' '}
							<Link to="/login" className="link link-primary">
								Login
							</Link>{' '}
							with your new password.
						</p>
					</>
				) : (
					<Form className="space-y-6" method="post" onSubmit={handleValidate}>
						<p>
							Enter your username or mobile number. If there is a valid mobile
							number associated with your account, you will receive a link to
							reset your password.
						</p>
						{actionData?.error && (
							<p className="py-4 text-red-600">
								An error occurred while attempting to change your password.
								Please try again.
							</p>
						)}
						<div className="form-control">
							<label htmlFor="password1" className="label label-text">
								Password
							</label>
							<input
								id="password1"
								name="password1"
								type="password"
								autoComplete="new-password"
								required
								className="w-full input input-sm input-bordered"
								value={password1}
								onChange={(e) => setPassword1(e.target.value)}
								minLength={8}
							/>
						</div>
						<label className="form-control" htmlFor="password2">
							<div className="label">
								<span className="label-text">Confirm Password</span>
							</div>
							<input
								id="password2"
								name="password2"
								type="password"
								autoComplete="new-password"
								required
								className={cn('w-full', 'input', 'input-sm', 'input-bordered', {
									'input-error': !passwordsMatch,
								})}
								value={password2}
								onChange={(e) => setPassword2(e.target.value)}
							/>
							{!passwordsMatch && (
								<div className="label">
									<span className="label-text text-error">
										Passwords do not match
									</span>
								</div>
							)}
						</label>
						<div>
							<input
								type="hidden"
								name="accessToken"
								value={searchParams.get('token')}
							/>
							<button
								className="text-white btn btn-primary btn-sm btn-block"
								name="form"
								value="resetPassword"
							>
								Change Password
							</button>
						</div>
					</Form>
				)}
			</div>
		</div>
	);
};

export default ChangePassword;
